import React from "react"
import { Helmet } from "react-helmet"


const SchemaLinksToAbsolute = (theSchema) => {
    
    // const schema = breadcrumb.breadcrumb
    // console.log(schema)
    const thePage = theSchema.page
    //console.log(thePage)
    const schema = JSON.parse(theSchema.schemaRaw)
    schema['@graph'].map(i => {
      // console.log(i)
      if(i['@type'] === 'WebSite' || i['@type'] === 'WebPage'){
        i['@id'] = process.env.GATSBY_SITE_URL+i['@id']
        i['url'] = process.env.GATSBY_SITE_URL+i['url']
        
        i.potentialAction.map(action => {
            if(action['@type'] === 'ReadAction'){
              action.target = process.env.GATSBY_SITE_URL+action.target
            }
            if(action['@type'] === 'SearchAction'){
              action.target.urlTemplate = process.env.GATSBY_SITE_URL+action.target.urlTemplate
            }
        })
      }

      if(i['@type'] === 'WebPage'){
        i['breadcrumb']['@id'] = process.env.GATSBY_SITE_URL+i['breadcrumb']['@id']
        i['isPartOf']['@id'] = process.env.GATSBY_SITE_URL+i['isPartOf']['@id']

        if(thePage === 'blogPost'){
          i['author'] = {
            "@type": "Person",
            name:theSchema.author,
            image:{
              "@type": "ImageObject",
              "@id":process.env.GATSBY_SITE_URL+'/#personlogo',
              inLanguage: 'en-GB',
              url:theSchema.gravatar,
              contentUrl:theSchema.gravatar,
              caption:theSchema.author
            }
          }
        }
      }

      if(i['@type'] === 'BreadcrumbList'){
        i['@id'] = process.env.GATSBY_SITE_URL+i['@id']
        i.itemListElement.map(item => {
          if(item.item !== undefined){
            item.item = process.env.GATSBY_SITE_URL+item.item
          }
        })
      }
    })
    //console.log(schema)
    return <Helmet><script type="application/ld+json">{JSON.stringify(schema)}</script></Helmet>
    
}

export {SchemaLinksToAbsolute}